import { useEffect, useState } from 'react';
import adminService from '../../../../services/adminService';

const PassengersModal = ({ isOpen, onClose, booking }) => {
  const [passengers, setPassengers] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (isOpen && booking) {
      fetchPassengers();
    }
  }, [isOpen, booking]);

  const fetchPassengers = async () => {
    setLoading(true);
    try {
      const response = await adminService.getBookingPassengers(booking.booking_token);
      setPassengers(response.data || []);
    } catch (error) {
      console.error('Error fetching passengers:', error);
      setPassengers([]);
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 px-4">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-2xl max-h-[70vh] overflow-hidden">
        {/* Header */}
        <div className="bg-[#03538f] text-white px-4 py-3 flex items-center justify-between">
          <h2 className="text-white text-md font-medium flex items-center gap-2 m-0">
            <i className="fas fa-users"></i>
            Passengers Details — {booking?.reference_number || 'N/A'}
          </h2>
          <button
            onClick={onClose}
            className="text-white hover:text-gray-200 text-2xl leading-none"
          >
            &times;
          </button>
        </div>

        {/* Body */}
        <div className="p-4 overflow-y-auto max-h-[calc(70vh-120px)]">
          {loading ? (
            <div className="text-center py-12">
              <i className="fas fa-spinner fa-spin text-3xl text-gray-400"></i>
              <p className="mt-4 text-gray-600">Loading passengers...</p>
            </div>
          ) : passengers.length > 0 ? (
            <div className="overflow-x-auto">
              <table className="w-full border-collapse border border-gray-300">
                <thead>
                  <tr className="bg-gray-100">
                    <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700 border border-gray-300">USER ID</th>
                    <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700 border border-gray-300">FIRST NAME</th>
                    <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700 border border-gray-300">LAST NAME</th>
                    <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700 border border-gray-300">EMAIL</th>
                    <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700 border border-gray-300">MOBILE NUMBER</th>
                  </tr>
                </thead>
                <tbody className="bg-white">
                  {passengers.map((passenger, index) => (
                    <tr key={passenger.id} className="hover:bg-gray-50">
                      <td className="px-4 py-3 text-sm text-gray-700 border border-gray-300">{passenger.user_type_id || '-'}</td>
                      <td className="px-4 py-3 text-sm text-gray-700 border border-gray-300">{passenger.first_name || '-'}</td>
                      <td className="px-4 py-3 text-sm text-gray-700 border border-gray-300">{passenger.last_name || '-'}</td>
                      <td className="px-4 py-3 text-sm text-gray-700 border border-gray-300">{passenger.email || '-'}</td>
                      <td className="px-4 py-3 text-sm text-gray-700 border border-gray-300">{passenger.mobile_number || '-'}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <div className="text-center py-12 text-gray-500">
              No passengers found for this booking.
            </div>
          )}
        </div>

        {/* Footer */}
        <div className="bg-gray-50 px-4 py-3 flex justify-end border-t border-gray-200">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-gray-500 text-white rounded hover:bg-gray-600 transition-colors text-sm"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default PassengersModal;
